import React from 'react';
import { Doughnut, Bar, HorizontalBar } from 'react-chartjs-2';
import ReactSpeedometer from "react-d3-speedometer";

const CarrierViewComponentNotFast = (props) => {
    console.log(props);
    const { riskData, quoteScores, messages } = props;
    const style = {
        animationDelay: '.5s',
        color: '#9c9c9c'
    };

    const data = {
        labels: ["Risk", "No Risk"],
        datasets: [{
            //label: '# of Votes',
            data: [1, (10-1)],
            backgroundColor: [                
                'red',
                '#1da83f',
            ],
            borderColor: [
                'red',
                '#1da83f',
            ],
            borderWidth: 1,
            options: {
                responsive: true,
                labels: {
                    display: true,
                    onClick: null
                },
                legends: {
                    display: true,
                    onClick: null,
                    onHover: null
                }
            }
        }]
    }

    return (
        <div style={style} className="card carrierView animated flipInX">
            <div className="card-body">
                {JSON.stringify(riskData)}
                <div style={{
                    textAlign: 'center'
                }}>
                    <h4>LightSpeed Decisioning</h4>
                    <ul>
                        <li>
                            <strong>Risk Score </strong>                            
                            <div style={{
                                width: "100%", height: "180px", background: "#fff"
                            }}>
                            <ReactSpeedometer 
                                fluidWidth="true" 
                                forceRender="true"                                
                                ringWidth="20" 
                                startColor="green" 
                                endColor="red" 
                                value="1500" 
                                maxValue="4990" />
                            </div>
                            {/*
                            <p>
                                {riskData.scoreDecile ? riskData.scoreDecile.description : ''}                                
                            </p>
                             */}
                        </li>
                        <li>
                            <strong>Decile</strong>
                            {/*
                            {riskData.scoreDecile ? riskData.scoreDecile.code : ''}
                            */} 1 out of 10
                            {/*
                            <p>{riskData.riskGroup}</p>
                             */}
                             <p>Good</p>
                            <Doughnut data={
                                data
                            }
                                legend={{
                                    display: true,
                                    onClick: null,
                                    onHover: null
                                }}
                            />
                        </li>
                        <li>
                            <strong>Fraud Indicator</strong> {riskData.isFraudIndicator === null ? null : riskData.isFraudIndicator.toString()}
                        </li>
                        <li>
                            <strong>Application Completeness Code</strong> {quoteScores ? quoteScores.applicationCompletenessCode : ''}                            
                        </li>
                        <li>
                            <strong>Rating Completeness Code</strong> {quoteScores ? quoteScores.ratingCompletenessCode : ''}
                        </li>
                    </ul>
                </div>
            </div>
        </div>

    )
};

export default CarrierViewComponentNotFast;


// WEBPACK FOOTER //
// ./src/SectionTitle/components/CarrierViewComponent-Not-fast-lane.js